var TokenCache =
/** @class */
function () {
  function TokenCache(logger) {
    this._logger = logger;
  }

  TokenCache.prototype.GetKey = function (userIdentifier) {
    return "iexpertsnl." + userIdentifier + ".license.token";
  };
  /**
   * Returns a cached ILicenseToken instance if there is one, else undefined.
   */


  TokenCache.prototype.Get = function (userIdentifier) {
    if (!localStorage) {
      this._logger.LogWarning("Local storage feature is not supported in this browser, therefore localstorage cannot be used for caching license tokens.");

      return;
    }

    var key = this.GetKey(userIdentifier);
    var cachedVersion = localStorage.getItem(key);

    if (cachedVersion !== null && cachedVersion.length > 0) {
      this._logger.LogInfo("Found cached license token, try to parse it.");

      try {
        return JSON.parse(cachedVersion);
      } catch (_a) {
        console.warn("Could not parse local storage version of license token.");
        return undefined;
      }
    }

    return undefined;
  };
  /**
   * Persists the specified ILicenseToken instance in the cache.
   * @param token ILicenseToken instance
   */


  TokenCache.prototype.Set = function (userIdentifier, token) {
    if (!localStorage) {
      this._logger.LogWarning("Local storage feature is not supported in this browser, therefore localstorage cannot be used for caching license tokens.");

      return;
    }

    this._logger.LogInfo("Setting license token in cache.");

    var key = this.GetKey(userIdentifier);
    localStorage.setItem(key, JSON.stringify(token));
  };
  /**
   * Removes the cached ILicenseToken instance from the cache.
   */


  TokenCache.prototype.Remove = function (userIdentifier) {
    if (!localStorage) {
      this._logger.LogWarning("Local storage feature is not supported in this browser, therefore localstorage cannot be used for caching license tokens.");

      return;
    }

    this._logger.LogInfo("Removing cached license token.");

    var key = this.GetKey(userIdentifier);
    localStorage.removeItem(key);
  };

  return TokenCache;
}();

export { TokenCache };